import axios from '@/plugins/axios'

export default {
  /**
   * Get change history
   */
  async getChangeHistory (params = {}) {
    const response = await axios.get('/admin/activity-logs', { params })
    return response.data
  },

  /**
   * Get change log details by UUID
   */
  async getChangeLogDetails (uuid) {
    const response = await axios.get(`/admin/activity-logs/${uuid}`)
    return response.data
  }
}
